export const MOCK_DATA = {
    "subTotal": "50,04",
    "total": "50,04",
    "shipping": "50,00",
    "shippingPlaces": {
        "72536-190": 50
    },
    "installments": [
        {
            "num": 1,
            "label": "\u00e0 vista (R$50,04)"
        },
        {
            "num": 2,
            "label": "2x sem juros (R$25,02 cada)"
        },
        {
            "num": 3,
            "label": "3x sem juros (R$16,68 cada)"
        },
        {
            "num": 4,
            "label": "4x (R$14,77 cada)"
        },
        {
            "num": 5,
            "label": "5x (R$12,20 cada)"
        },
        {
            "num": 6,
            "label": "6x (R$10,50 cada)"
        },
        {
            "num": 7,
            "label": "7x (R$9,29 cada)"
        },
        {
            "num": 8,
            "label": "8x (R$8,38 cada)"
        },
        {
            "num": 9,
            "label": "9x (R$7,68 cada)"
        },
        {
            "num": 10,
            "label": "10x (R$7,12 cada)"
        },
        {
            "num": 11,
            "label": "11x (R$6,67 cada)"
        },
        {
            "num": 12,
            "label": "12x (R$6,30 cada)"
        }
    ],
    "coupon": null,
    "qtyItems": 4,
    "items": [
        {
            "id": 879,
            "productId": 1,
            "productCategories": [
                {
                    "id": 4,
                    "name": "Vacinas",
                    "icon": null,
                    "urlKey": "vacinas",
                    "termUse": null
                },
                {
                    "id": 17,
                    "name": "Unidades COVID",
                    "icon": null,
                    "urlKey": "unidades-covid",
                    "termUse": null
                },
                {
                    "id": 18,
                    "name": "Exames Laboratoriais",
                    "icon": null,
                    "urlKey": "exames-laboratoriais",
                    "termUse": null
                }
            ],
            "cartItemId": 879,
            "name": "Vacina Braba",
            "image": "https:\/\/5a59-179-76-51-19.ngrok-free.app\/media\/catalog\/product\/cache\/1\/small_image\/88x77\/9df78eab33525d08d6e5fb8d27136e95\/images\/catalog\/product\/placeholder\/small_image.jpg",
            "price": "0,01",
            "qty": 12,
            "unity": "Domiciliar #2",
            "categoryServiceType": "Vacinas",
            "cep": "72536-190",
            "shipping": 50,
            "total": "0,01",
            "typeMarkdown": null,
            "stockItem": 15,
            "stockData": [
                {
                    "id": 1,
                    "name": "516 Norte",
                    "type": {
                        "name": "Unidade",
                        "label": "unity"
                    },
                    "stockQty": 9744,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 12,
                    "name": "Samambaia Norte",
                    "type": {
                        "name": "Atendimento drive-thru",
                        "label": "drivethru"
                    },
                    "stockQty": 99987,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 15,
                    "name": "Domiciliar #2",
                    "type": {
                        "name": "Domic\u00edlio",
                        "label": "home_delivery"
                    },
                    "stockQty": 9994,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 16,
                    "name": "Unidade Drive",
                    "type": {
                        "name": "Unidade 24h",
                        "label": "unidade_drive"
                    },
                    "stockQty": 999997,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 100,
                    "name": "Autoatendimento",
                    "type": {
                        "name": "Autoatendimento Sabin Express",
                        "label": "self_service"
                    },
                    "stockQty": 999997,
                    "stockStatus": "In Stock"
                }
            ]
        },
        {
            "id": 878,
            "productId": 1,
            "productCategories": [
                {
                    "id": 4,
                    "name": "Vacinas",
                    "icon": null,
                    "urlKey": "vacinas",
                    "termUse": null
                },
                {
                    "id": 17,
                    "name": "Unidades COVID",
                    "icon": null,
                    "urlKey": "unidades-covid",
                    "termUse": null
                },
                {
                    "id": 18,
                    "name": "Exames Laboratoriais",
                    "icon": null,
                    "urlKey": "exames-laboratoriais",
                    "termUse": null
                }
            ],
            "cartItemId": 878,
            "name": "Vacina Herpes Zóster - SHINGRIX (Combo de 2 doses para uma pessoa)",
            "image": "https:\/\/5a59-179-76-51-19.ngrok-free.app\/media\/catalog\/product\/cache\/1\/small_image\/88x77\/9df78eab33525d08d6e5fb8d27136e95\/images\/catalog\/product\/placeholder\/small_image.jpg",
            "price": "0,01",
            "qty": 1,
            "unity": "Autoatendimento",
            "categoryServiceType": "CheckUps",
            "cep": null,
            "shipping": 0,
            "total": "0,01",
            "typeMarkdown": null,
            "stockItem": 16,
            "stockData": [
                {
                    "id": 1,
                    "name": "516 Norte",
                    "type": {
                        "name": "Unidade",
                        "label": "unity"
                    },
                    "stockQty": 9744,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 12,
                    "name": "Samambaia Norte",
                    "type": {
                        "name": "Atendimento drive-thru",
                        "label": "drivethru"
                    },
                    "stockQty": 99987,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 15,
                    "name": "Domiciliar #2",
                    "type": {
                        "name": "Domic\u00edlio",
                        "label": "home_delivery"
                    },
                    "stockQty": 9994,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 16,
                    "name": "Unidade Drive",
                    "type": {
                        "name": "Unidade 24h",
                        "label": "unidade_drive"
                    },
                    "stockQty": 999997,
                    "stockStatus": "In Stock"
                },
                {
                    "id": 100,
                    "name": "Autoatendimento",
                    "type": {
                        "name": "Autoatendimento Sabin Express",
                        "label": "self_service"
                    },
                    "stockQty": 999997,
                    "stockStatus": "In Stock"
                }
            ]
        },
        // {
        //     "id": 877,
        //     "productId": 1,
        //     "productCategories": [
        //         {
        //             "id": 4,
        //             "name": "Vacinas",
        //             "icon": null,
        //             "urlKey": "vacinas",
        //             "termUse": null
        //         },
        //         {
        //             "id": 17,
        //             "name": "Unidades COVID",
        //             "icon": null,
        //             "urlKey": "unidades-covid",
        //             "termUse": null
        //         },
        //         {
        //             "id": 18,
        //             "name": "Exames Laboratoriais",
        //             "icon": null,
        //             "urlKey": "exames-laboratoriais",
        //             "termUse": null
        //         }
        //     ],
        //     "cartItemId": 877,
        //     "name": "Vacina Braba",
        //     "image": "https:\/\/5a59-179-76-51-19.ngrok-free.app\/media\/catalog\/product\/cache\/1\/small_image\/88x77\/9df78eab33525d08d6e5fb8d27136e95\/images\/catalog\/product\/placeholder\/small_image.jpg",
        //     "price": "0,01",
        //     "qty": 1,
        //     "unity": "Samambaia Norte",
        //     "cep": null,
        //     "shipping": 0,
        //     "total": "0,01",
        //     "typeMarkdown": null,
        //     "stockItem": 12,
        //     "stockData": [
        //         {
        //             "id": 1,
        //             "name": "516 Norte",
        //             "type": {
        //                 "name": "Unidade",
        //                 "label": "unity"
        //             },
        //             "stockQty": 9744,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 12,
        //             "name": "Samambaia Norte",
        //             "type": {
        //                 "name": "Atendimento drive-thru",
        //                 "label": "drivethru"
        //             },
        //             "stockQty": 99987,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 15,
        //             "name": "Domiciliar #2",
        //             "type": {
        //                 "name": "Domic\u00edlio",
        //                 "label": "home_delivery"
        //             },
        //             "stockQty": 9994,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 16,
        //             "name": "Unidade Drive",
        //             "type": {
        //                 "name": "Unidade 24h",
        //                 "label": "unidade_drive"
        //             },
        //             "stockQty": 999997,
        //             "stockStatus": "In Stock"
        //         }
        //     ]
        // },
        // {
        //     "id": 876,
        //     "productId": 1,
        //     "productCategories": [
        //         {
        //             "id": 4,
        //             "name": "Vacinas",
        //             "icon": null,
        //             "urlKey": "vacinas",
        //             "termUse": null
        //         },
        //         {
        //             "id": 17,
        //             "name": "Unidades COVID",
        //             "icon": null,
        //             "urlKey": "unidades-covid",
        //             "termUse": null
        //         },
        //         {
        //             "id": 18,
        //             "name": "Exames Laboratoriais",
        //             "icon": null,
        //             "urlKey": "exames-laboratoriais",
        //             "termUse": null
        //         }
        //     ],
        //     "cartItemId": 876,
        //     "name": "Vacina Braba",
        //     "image": "https:\/\/5a59-179-76-51-19.ngrok-free.app\/media\/catalog\/product\/cache\/1\/small_image\/88x77\/9df78eab33525d08d6e5fb8d27136e95\/images\/catalog\/product\/placeholder\/small_image.jpg",
        //     "price": "0,01",
        //     "qty": 1,
        //     "unity": "516 Norte",
        //     "cep": null,
        //     "shipping": 0,
        //     "total": "0,01",
        //     "typeMarkdown": null,
        //     "stockItem": 1,
        //     "stockData": [
        //         {
        //             "id": 1,
        //             "name": "516 Norte",
        //             "type": {
        //                 "name": "Unidade",
        //                 "label": "unity"
        //             },
        //             "stockQty": 9744,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 12,
        //             "name": "Samambaia Norte",
        //             "type": {
        //                 "name": "Atendimento drive-thru",
        //                 "label": "drivethru"
        //             },
        //             "stockQty": 99987,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 15,
        //             "name": "Domiciliar #2",
        //             "type": {
        //                 "name": "Domic\u00edlio",
        //                 "label": "home_delivery"
        //             },
        //             "stockQty": 9994,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 16,
        //             "name": "Unidade Drive",
        //             "type": {
        //                 "name": "Unidade 24h",
        //                 "label": "unidade_drive"
        //             },
        //             "stockQty": 999997,
        //             "stockStatus": "In Stock"
        //         }
        //     ]
        // },
        // {
        //     "id": 875,
        //     "productId": 1,
        //     "productCategories": [
        //         {
        //             "id": 4,
        //             "name": "Vacinas",
        //             "icon": null,
        //             "urlKey": "vacinas",
        //             "termUse": null
        //         },
        //         {
        //             "id": 17,
        //             "name": "Unidades COVID",
        //             "icon": null,
        //             "urlKey": "unidades-covid",
        //             "termUse": null
        //         },
        //         {
        //             "id": 18,
        //             "name": "Exames Laboratoriais",
        //             "icon": null,
        //             "urlKey": "exames-laboratoriais",
        //             "termUse": null
        //         }
        //     ],
        //     "cartItemId": 876,
        //     "name": "Vacina Braba",
        //     "image": "https:\/\/5a59-179-76-51-19.ngrok-free.app\/media\/catalog\/product\/cache\/1\/small_image\/88x77\/9df78eab33525d08d6e5fb8d27136e95\/images\/catalog\/product\/placeholder\/small_image.jpg",
        //     "price": "0,01",
        //     "qty": 1,
        //     "unity": "516 Norte",
        //     "cep": null,
        //     "shipping": 0,
        //     "total": "0,01",
        //     "typeMarkdown": null,
        //     "stockItem": 1,
        //     "stockData": [
        //         {
        //             "id": 1,
        //             "name": "516 Norte",
        //             "type": {
        //                 "name": "Unidade",
        //                 "label": "unity"
        //             },
        //             "stockQty": 9744,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 12,
        //             "name": "Samambaia Norte",
        //             "type": {
        //                 "name": "Atendimento drive-thru",
        //                 "label": "drivethru"
        //             },
        //             "stockQty": 99987,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 15,
        //             "name": "Domiciliar #2",
        //             "type": {
        //                 "name": "Domic\u00edlio",
        //                 "label": "home_delivery"
        //             },
        //             "stockQty": 9994,
        //             "stockStatus": "In Stock"
        //         },
        //         {
        //             "id": 16,
        //             "name": "Unidade Drive",
        //             "type": {
        //                 "name": "Unidade 24h",
        //                 "label": "unidade_drive"
        //             },
        //             "stockQty": 999997,
        //             "stockStatus": "In Stock"
        //         }
        //     ]
        // }
    ],
    "formKey": "e5gHy5Ncl24lWM4L"
}
